import React, { useState, Fragment } from "react";
import Img from "gatsby-image";
import { Dialog } from "@reach/dialog";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useWindowDimensions } from "../hooks/useWindowDimensions";

export default function ImageGallery(props) {

    const windowHeight = useWindowDimensions()?.height || 0;

    const [showLightbox, setShowLightbox] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    const [imageWidth, setImageWidth] = useState(100);

    const setImage = (index) => {
        let lastIndex = props.images.length - 1;

        if (index > lastIndex) {
            index = 0;
        } else if (index < 0) {
            index = lastIndex;
        }

        const headerFooterSpace = 150;
        let image = props.images[index].childImageSharp.fluid;
        let imageHeight = windowHeight - headerFooterSpace;
        let imageWidth = imageHeight * image.aspectRatio;

        setSelectedImageIndex(index);
        setImageWidth(imageWidth);
        setShowLightbox(true);
    };

    const images = props.images.map((image, index) => {
        return (
            <button type="button" className="image-button" onClick={() => setImage(index)} key={index}>
                <Img fluid={image.childImageSharp?.fluid} imgStyle={{ objectFit: "cover", objectPosition: "50% 50%", }} />
            </button>
        );
    });

    return (
        <Fragment>
            <div className="image-gallery">{images}</div>
            {showLightbox && (
                <Dialog aria-label="image lightbox">
                    <div className="image-gallery-lightbox">
                        <div className="top">
                            <button type="button" className="close-button" onClick={() => setShowLightbox(false)}>
                                <FontAwesomeIcon icon='times' />
                            </button>
                        </div>
                        <div className="image-container">
                            <Img fluid={props.images[selectedImageIndex].childImageSharp.fluid} style={{ width: imageWidth + 'px'}} />
                        </div>
                        <div className="bottom">
                            <button type="button" className="prev-button" onClick={() => setImage(selectedImageIndex - 1)}>
                                <FontAwesomeIcon icon='chevron-left' /><span> Previous</span>
                            </button>
                            <button type="button" className="next-button" onClick={() => setImage(selectedImageIndex + 1)}>
                                <span>Next </span><FontAwesomeIcon icon='chevron-right' />
                            </button>
                        </div>
                    </div>
                </Dialog>
            )}
        </Fragment>
    );
}